<pg-home-section-3>
  <section id="home-section-3">
    <header>
      <h2>Como Fazemos</h2>
      <p>Conheça as etapas de atendimento da VLGI Corporate:</p>
    </header>
    <div class="container">
      <div class="content">
        <ul>
          <li>Esta é a etapa em que entendemos o perfil, as características e as necessidades do seu negócio.</li>
          <li>Após estudar o que faz sentido para sua empresa, lhe apresentaremos as soluções adequadas para o que você precisa.</li>
          <li>A nossa atuação vai além da curadoria das soluções para o seu negócio. Estamos falando de uma construção de relacionamento de longo prazo pautado pelo serviço de excelência e proximidade.</li>
        </ul>
      </div>
      <img src={illustration} alt="Ilustração do que fazemos" class="illustration">
    </div>
  </section>

  <script>
    import './pg-home-section-3.scss'

    import illustration from '../../media/illustration.png'

    export default {
      illustration
    }
  </script>
</pg-home-section-3>
